import type { Hub, Period, State } from '@/models/catalog/offer';

export interface SelectOption<T = string> {
  label: string;
  value: T;
}

export const mountStatesOptions = (states: State[]): SelectOption[] =>
  states.map(({ abbreviation, name }) => ({
    label: name,
    value: abbreviation,
  }));

export const mountCitiesOptions = (cities: string[]): SelectOption[] =>
  cities.map((city) => ({
    label: city,
    value: city,
  }));

export const mountHubsOptions = (hubs: Hub[]): SelectOption<number>[] =>
  hubs.map(({ id, name }) => ({
    label: name,
    value: id,
  }));

export const mountPeriodsOptions = (periods: Period[]): SelectOption[] =>
  periods.map(({ label, type }) => ({
    label,
    value: type,
  }));
